import { PiUsers } from 'react-icons/pi'

import FbButton from 'components/FbUI/FbButton'
import { TargetArrowIcon } from 'components/Layout/LeftNav/nav-icons'
import { ContactRequestJobFromCampaignModal } from 'components/Modals/ContactRequestJobFromCampaignModal'

interface CampaignContactsZeroStateProps {
  hasContactRequests: boolean
  campaignId: number
  isMultiType?: boolean
  onSwitchToTargets: () => void
  onContactRequested?: () => void
  variant: 'assign-targets' | 'request-contacts'
}

export function CampaignContactsZeroState({
  hasContactRequests,
  campaignId,
  isMultiType = false,
  onSwitchToTargets,
  onContactRequested,
  variant,
}: CampaignContactsZeroStateProps) {
  if (variant === 'assign-targets') {
    return (
      <div className="rounded-lg border border-line bg-surface p-12 text-center">
        <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-surface-alt">
          <PiUsers className="size-7 text-fg-muted" />
        </div>
        <p className="mb-1 text-base text-fg">Assign targets first</p>
        <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
          Before requesting contacts, you need to assign a target list to this
          campaign.
        </p>
        <FbButton
          type="button"
          className="mx-auto !bg-brand-bright !text-white hover:!bg-brand-active"
          onClick={onSwitchToTargets}
        >
          <TargetArrowIcon size={18} />
          Go to Targets
        </FbButton>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-line bg-surface p-12 text-center">
      <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-brand-active/10">
        <PiUsers className="size-7 text-brand-active" />
      </div>
      <p className="mb-1 text-base text-fg">Request contacts</p>
      <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
        This campaign has targets, but contacts have not been requested yet.
      </p>
      {hasContactRequests ? (
        <div className="flex justify-center">
          <ContactRequestJobFromCampaignModal
            campaignId={campaignId}
            isMultiType={isMultiType}
            buttonText="Request Contacts"
            onContactRequested={onContactRequested}
          />
        </div>
      ) : (
        <p className="text-sm text-fg-secondary">
          Contact requests are not available for this campaign type.
        </p>
      )}
    </div>
  )
}
